import { useQuery } from '@apollo/client';
import LoadingIndicator from 'components/LoadingIndicator';
import Navbar from 'components/Navbar';
import UsersTable from 'components/Tables/Users';
import { useUser } from 'contexts/userContext';
import {
  GET_REPORTEES_QUERY,
  GetReporteesResponse,
  GetReporteesVariables,
} from 'graphql/query/user';
import { getSelectedObjectiveGoalsYear } from 'utils/common';

const TeamPage = () => {
  const { user: loggedInUser } = useUser();
  const { data: reportees, loading: loadingReportees } = useQuery<
    GetReporteesResponse,
    GetReporteesVariables
  >(GET_REPORTEES_QUERY, {
    variables: {
      userId: loggedInUser?._id!,
      year: getSelectedObjectiveGoalsYear(),
    },
    fetchPolicy: 'network-only',
  });

  return (
    <Navbar title={`Teams - ${getSelectedObjectiveGoalsYear()}`}>
      {loadingReportees ? (
        <LoadingIndicator />
      ) : (
        <UsersTable title="Reportees" rows={reportees?.getReportees ?? []} />
      )}
    </Navbar>
  );
};

export default TeamPage;
